/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScheduleTimeOffUpdateRequest = {
    properties: {
        date: {
    type: 'string',
    isRequired: true,
    format: 'date',
},
        reason: {
    type: 'string',
},
    },
};